/**
 * OMNIVASO i18n Module — French (fr)
 * Hand-curated. All keys must mirror en.js exactly.
 */
const fr = {
    nav: {
        home:            'Accueil',
        shop:            'Boutique',
        cart:            'Panier',
        search:          'Rechercher',
        articles:        'Articles',
        blog:            'Blog',
        about:           'À propos',
        contact:         'Contact',
        account:         'Mon compte',
        orders:          'Mes commandes',
        login:           'Connexion',
        logout:          'Déconnexion',
        openMenu:        'Ouvrir le menu',
        closeMenu:       'Fermer le menu',
        skipToContent:   'Aller au contenu',
    },

    actions: {
        readMore:        'Lire la suite',
        viewAll:         'Voir tout',
        learnMore:       'En savoir plus',
        back:            'Retour',
        close:           'Fermer',
        save:            'Enregistrer',
        cancel:          'Annuler',
        submit:          'Soumettre',
        confirm:         'Confirmer',
        delete:          'Supprimer',
        edit:            'Modifier',
        add:             'Ajouter',
        remove:          'Retirer',
        search:          'Rechercher',
        reset:           'Réinitialiser',
        next:            'Suivant',
        previous:        'Précédent',
        loading:         'Chargement...',
        tryAgain:        'Réessayer',
        copy:            'Copier',
        share:           'Partager',
        download:        'Télécharger',
        upload:          'Téléverser',
        apply:           'Appliquer',
        clear:           'Effacer',
    },

    status: {
        success:         'Succès !',
        error:           'Une erreur est survenue. Veuillez réessayer.',
        saved:           'Enregistré avec succès.',
        notFound:        'Page introuvable.',
        comingSoon:      'Bientôt disponible.',
        outOfStock:      'Rupture de stock',
        inStock:         'En stock',
        soldOut:         'Épuisé',
        new:             'Nouveau',
        sale:            'Soldes',
        featured:        'En vedette',
        noResults:       'Aucun résultat trouvé.',
        required:        'Ce champ est obligatoire.',
        invalidEmail:    'Veuillez entrer une adresse e-mail valide.',
    },

    shop: {
        addToCart:       'Ajouter au panier',
        addedToCart:     'Ajouté au panier',
        viewCart:        'Voir le panier',
        checkout:        'Passer à la caisse',
        continueShopping:'Continuer les achats',
        orderSummary:    'Récapitulatif de commande',
        orderTotal:      'Total de la commande',
        subtotal:        'Sous-total',
        shipping:        'Livraison',
        tax:             'Taxes',
        discount:        'Réduction',
        couponCode:      'Code promo',
        applyCoupon:     'Appliquer le coupon',
        quantity:        'Quantité',
        price:           'Prix',
        total:           'Total',
        remove:          'Retirer',
        emptyCart:       'Votre panier est vide.',
        browseProducts:  'Parcourir les produits',
        product:         'Produit',
        products:        'Produits',
        category:        'Catégorie',
        categories:      'Catégories',
        sortBy:          'Trier par',
        filterBy:        'Filtrer par',
        allProducts:     'Tous les produits',
        searchProducts:  'Rechercher des produits...',
        productDetails:  'Détails du produit',
        relatedProducts: 'Produits similaires',
        stockLeft:       'restant en stock',
        freeShipping:    'Livraison gratuite',
        placeOrder:      'Passer la commande',
        orderConfirmed:  'Commande confirmée !',
        trackOrder:      'Suivre la commande',
        orderNumber:     'Numéro de commande',
        paymentMethod:   'Méthode de paiement',
        billingAddress:  'Adresse de facturation',
        shippingAddress: 'Adresse de livraison',
        firstName:       'Prénom',
        lastName:        'Nom de famille',
        email:           'Adresse e-mail',
        phone:           'Numéro de téléphone',
        address:         'Adresse',
        city:            'Ville',
        province:        'Province / État',
        postalCode:      'Code postal',
        country:         'Pays',
        secureCheckout:  'Paiement sécurisé',
        payWith:         'Payer avec',
    },

    articles: {
        by:              'Par',
        publishedOn:     'Publié le',
        minuteRead:      'min de lecture',
        tags:            'Étiquettes',
        share:           'Partager cet article',
        relatedArticles: 'Articles similaires',
        allArticles:     'Tous les articles',
        noArticles:      'Aucun article trouvé.',
        searchArticles:  'Rechercher des articles...',
    },

    search: {
        placeholder:     'Rechercher des produits, articles, pages...',
        results:         'Résultats',
        noResults:       'Aucun résultat pour',
        searching:       'Recherche en cours...',
        searchTip:       'Appuyez sur ⌘K ou Ctrl+K pour rechercher',
        quickSearch:     'Recherche rapide',
    },

    newsletter: {
        subscribe:       'S\'abonner',
        subscribeTitle:  'Restez informé',
        subscribeDesc:   'Recevez les dernières nouvelles dans votre boîte de réception.',
        emailPlaceholder:'Entrez votre e-mail',
        thankYou:        'Merci de votre inscription !',
        alreadySubscribed:'Vous êtes déjà abonné.',
        privacyNote:     'Nous respectons votre vie privée. Désabonnez-vous à tout moment.',
    },

    footer: {
        rights:          'Tous droits réservés.',
        privacy:         'Politique de confidentialité',
        terms:           'Conditions d\'utilisation',
        sitemap:         'Plan du site',
        poweredBy:       'Propulsé par',
        contactUs:       'Nous contacter',
        followUs:        'Suivez-nous',
        quickLinks:      'Liens rapides',
    },

    forms: {
        email:           'E-mail',
        password:        'Mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
        username:        'Nom d\'utilisateur',
        name:            'Nom',
        message:         'Message',
        subject:         'Sujet',
        send:            'Envoyer',
        sending:         'Envoi en cours...',
        sent:            'Message envoyé !',
        signIn:          'Se connecter',
        signUp:          'S\'inscrire',
        forgotPassword:  'Mot de passe oublié ?',
        rememberMe:      'Se souvenir de moi',
        changePassword:  'Changer le mot de passe',
        currentPassword: 'Mot de passe actuel',
        newPassword:     'Nouveau mot de passe',
    },

    i18n: {
        selectLanguage:  'Choisir la langue',
        language:        'Langue',
    },

    errors: {
        pageNotFound:    'Page introuvable',
        pageNotFoundDesc:'La page que vous cherchez n\'existe pas ou a été déplacée.',
        goHome:          'Retour à l\'accueil',
        somethingWrong:  'Une erreur est survenue',
        somethingWrongDesc: 'Une erreur inattendue s\'est produite. Vos données sont en sécurité.',
        returnToStorefront: 'Retour à la boutique',
    },
};

export default fr;
